import USBLoader from '@usb-shield/react-loader/dist/esm'
import { USBGrid, USBColumn } from '@usb-shield/react-grid/dist/esm/'

const SpinnerLoader = () => (
  <div
    className="padding-columns"
    style={{
      height: '100vh',
      zIndex: 9999,
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%'
    }}
  >
    <USBGrid padding="normal">
      <USBColumn mediumSpan={16} largeSpan={16}>
        <USBLoader determinate={false} variant="simple" />
      </USBColumn>
    </USBGrid>
  </div>
)

export default SpinnerLoader
